export const DEFAULT_NUMBER_OF_LABELS = 100;
export const MAX_NUMBER_OF_LABELS = 300;
export const MIN_NUMBER_OF_LABELS = 1;

export const MIN_SSCC_LABEL_ID = 1;

export const SSCC_SERIAL_BASE_LENGTH = 16;

export const getMaxSsccLabelId = (gs1CompanyPrefix) =>
	gs1CompanyPrefix ? 10 ** (SSCC_SERIAL_BASE_LENGTH - gs1CompanyPrefix.length) - 1 : null;
